import { get_edm_num } from '@/services/edm'
export default {
  data() {
    return {
      count: {
        all: 0, // 所有
        timing: 0, // 定时中
        sent: 0, // 已发送
        failed: 0, // 失败
        draft: 0 // 草稿箱
      }
    }
  },
  watch: {
    $route() {
      // console.log('change', this.$route)
    }
  },
  computed: {
    fullPath() {
      return this.$route.fullPath
    }
  },
  methods: {
    // 获取邮件各项数据
    async getMailCount() {
      const data = await get_edm_num({})
      if (data.errno == 0) {
        this.count = data.data
      }
    },
    jump(path, log) {
      if (log) {
        this.$log.action(log)
      }
      this.$router.push({ path })
      if (this.$refs.edmList && this.$refs.edmList.clearSort) {
        this.$refs.edmList.clearSort()
      }
    },
    gotoEdit() {
      this.$router.push({ path: '/edm/edit' })
      this.$log.action('click_create_market_email')
    }
  },
  mounted() {
    this.getMailCount()
  }
}
